import controller from "emun.cart/create-cart-prompt.controller";
import TEMPLATE_URL from "emun.cart/create-cart-prompt.htm";
import open from "webmodals/open";

export default ({
  size = "md",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  ...options
} = {}) =>
  open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  }).result;
